import { defineSlotRecipe } from '@chakra-ui/react'
import { avatarAnatomy } from '@chakra-ui/react/anatomy'

export const avatarSlotRecipe = defineSlotRecipe({
    slots: avatarAnatomy.keys(),
    variants: {
        size: {
            profile: {
                root: {
                    width: 10,
                    height: 10,
                    fontSize: '14px',
                },
            },
        },
    },
})
